import { useEffect } from 'react'

const CLOFO = 'Closing Folders'

export function usePageTitle(pageTitle: string) {
  useEffect(() => {
    document.title = pageTitle ? `${pageTitle} - ${CLOFO}` : CLOFO
  }, [pageTitle])
}
